export const columnsDataDevelopment = [
  "QUIZZ ID",
  "TITLE",
  "OPTION 1",
  "OPTION 2",
  "OPTION 3",
  "OPTION 4",
  "TYPE",
  "ANSWER",
  "ACTION",
];
